import {
  ADD_NEW_PATIENT,
  ADD_NEW_PATIENT_SUCCESS,
  ADD_NEW_PATIENT_FAILED,
  RESET_NEW_PATIENT_RESPONSE,
  FETCH_PATIENTS,
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENTS_FAILED,
  SET_PATIENT_INFO_NULL,
  FETCH_PATIENT_DATA_LOADING,
  FETCH_PATIENT_DATA,
  FETCH_PATIENT_DATA_SUCCESS,
  FETCH_PATIENT_DATA_FAILED,
  UPDATE_PATIENT,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAILED,
  UPDATE_PATIENT_DETAILS,
  UPDATE_PATIENT_DETAILS_SUCCESS,
  UPDATE_PATIENT_DETAILS_FAILED,
  UPDATE_RECENT_PATIENT_COUNT,
  UPDATE_RECENT_PATIENT_COUNT_SUCCESS,
  UPDATE_RECENT_PATIENT_COUNT_FAILED,
  SAVE_PATIENT_COMMENT,
  SAVE_PATIENT_COMMENT_SUCCESS,
  SAVE_PATIENT_COMMENT_FAILED,
  FETCH_PATIENT_COMMENT,
  FETCH_PATIENT_COMMENT_SUCCESS,
  FETCH_PATIENT_COMMENT_FAILED,
  UPDATE_PATIENT_COMMENT,
  DELETE_PATIENT_COMMENT,
  UPDATE_PATIENT_COMMENT_SUCCESS,
  UPDATE_PATIENT_COMMENT_FAILED,
  DELETE_PATIENT_COMMENT_SUCCESS,
  DELETE_PATIENT_COMMENT_FAILED,
  FETCH_DISEASE_LIST,
  FETCH_DISEASE_LIST_SUCCESS,
  FETCH_DISEASE_LIST_FAILED,
  FETCH_PATIENT_DISEASE,
  FETCH_PATIENT_DISEASE_SUCCESS,
  FETCH_PATIENT_DISEASE_FAILED,
  FETCH_CHECKUP_DATES,
  FETCH_CHECKUP_DATES_SUCCESS,
  FETCH_CHECKUP_DATES_FAILED,
  ADD_CHECKUP_DATE,
  ADD_CHECKUP_DATE_SUCCESS,
  ADD_CHECKUP_DATE_FAILED,
  CHECKUP_MARK_AS_COMPLETE,
  CHECKUP_MARK_AS_COMPLETE_SUCCESS,
  CHECKUP_MARK_AS_COMPLETE_FAILED,
  FETCH_PATIENTS_SUMMARY,
  FETCH_PATIENTS_SUMMARY_SUCCESS,
  FETCH_PATIENTS_SUMMARY_FAILED,
  GENERATE_PATIENT_ID,
  GENERATE_PATIENT_ID_SUCCESS,
  GENERATE_PATIENT_ID_FAILED,
  TOGGLE_PATIENT_STATUS,
  TOGGLE_PATIENT_STATUS_SUCCESS,
  TOGGLE_PATIENT_STATUS_FAILED,
  RESET_NEW_PATIENT_VALIDATION,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_SUCCESS,
  FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_FAILED,
  UPLOAD_PATIENT_REPORT,
  UPLOAD_PATIENT_REPORT_SUCCESS,
  UPLOAD_PATIENT_REPORT_FAILED,
  RESET_REPORT_ERROR,
  UPDATE_SAMPLE_PATIENT,
  UPDATE_SAMPLE_PATIENT_SUCCESS,
  UPDATE_SAMPLE_PATIENT_FAILED,
  REFRESH_STATISTICS,
  FETCH_PATIENTS_QNA_SUCCESS,
  FETCH_PATIENTS_QNA_FAILED,
  FETCH_PATIENTS_QNA,
  GENERATE_AUTOMATED_REPORT,
  GENERATE_AUTOMATED_REPORT_STATUS,
  GENERATE_AUTOMATED_REPORT_DATA,
  GENERATE_REPORT_SUCCESS,
  GENERATE_REPORT_FAILED,
} from "constants/ActionTypes";

export const fetch_patients = (payload) => ({
  type: FETCH_PATIENTS,
  payload,
});

export const fetch_patient_medication_symptoms_history = (payload) => ({
  type: FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY,
  payload,
});
export const fetch_patient_medication_symptoms_history_success = (payload) => ({
  type: FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_SUCCESS,
  payload,
});
export const fetch_patient_medication_symptoms_history_failed = (error) => ({
  type: FETCH_PATIENT_MEDICATION_SYMPTOMS_HISTORY_FAILED,
  error,
});

export const fetch_patients_success = (payload) => ({
  type: FETCH_PATIENTS_SUCCESS,
  payload,
});

export const fetch_patients_qna_response = (payload) => ({
  type: FETCH_PATIENTS_QNA,
  payload,
});

export const fetch_patients_qna_response_success = (payload) => ({
  type: FETCH_PATIENTS_QNA_SUCCESS,
  payload,
});

export const fetch_patients_qna_response_failed = (payload) => ({
  type: FETCH_PATIENTS_QNA_FAILED,
  payload,
});

export const reset_new_patient_response = () => ({
  type: RESET_NEW_PATIENT_RESPONSE,
});

export const fetch_patients_failed = (error) => ({
  type: FETCH_PATIENTS_FAILED,
  error,
});

export const set_patient_info_null = () => ({
  type: SET_PATIENT_INFO_NULL,
});

export const fetch_patient_data_loading = (payload) => ({
  type: FETCH_PATIENT_DATA_LOADING,
  payload,
});

export const fetch_patient_data = (patient_id) => ({
  type: FETCH_PATIENT_DATA,
  payload: {
    patient_id,
  },
});

export const fetch_patient_data_success = (payload) => ({
  type: FETCH_PATIENT_DATA_SUCCESS,
  payload,
});

export const fetch_patient_data_failed = (error) => ({
  type: FETCH_PATIENT_DATA_FAILED,
  error,
});

export const add_new_patient = (payload) => {
  return {
    type: ADD_NEW_PATIENT,
    payload,
  };
};

export const add_new_patient_success = (payload) => {
  return {
    type: ADD_NEW_PATIENT_SUCCESS,
    payload,
  };
};
export const add_new_patient_failed = (error) => {
  return {
    type: ADD_NEW_PATIENT_FAILED,
    error,
  };
};

export const update_patient_info = (payload) => {
  return {
    type: UPDATE_PATIENT,
    payload,
  };
};
export const update_patient_info_success = (payload) => {
  return {
    type: UPDATE_PATIENT_SUCCESS,
    payload,
  };
};
export const update_patient_info_failed = (error) => {
  return {
    type: UPDATE_PATIENT_FAILED,
    error,
  };
};

export const upload_patient_report = (payload) => {
  return {
    type: UPLOAD_PATIENT_REPORT,
    payload,
  };
};
export const upload_patient_report_success = (payload) => {
  return {
    type: UPLOAD_PATIENT_REPORT_SUCCESS,
    payload,
  };
};
export const upload_patient_report_failed = (error) => {
  return {
    type: UPLOAD_PATIENT_REPORT_FAILED,
    error,
  };
};

export const update_patient_details = (payload) => {
  return {
    type: UPDATE_PATIENT_DETAILS,
    payload,
  };
};
export const update_patient_details_success = (message) => {
  return {
    type: UPDATE_PATIENT_DETAILS_SUCCESS,
    message,
  };
};
export const update_patient_details_failed = (error) => {
  return {
    type: UPDATE_PATIENT_DETAILS_FAILED,
    error,
  };
};

export const update_recent_patient_count = (payload) => {
  return {
    type: UPDATE_RECENT_PATIENT_COUNT,
    payload,
  };
};
export const update_recent_patient_count_success = (payload) => {
  return {
    type: UPDATE_RECENT_PATIENT_COUNT_SUCCESS,
    payload,
  };
};
export const update_recent_patient_count_failed = (error) => {
  return {
    type: UPDATE_RECENT_PATIENT_COUNT_FAILED,
    error,
  };
};
export const add_patient_comment = (payload) => {
  return {
    type: SAVE_PATIENT_COMMENT,
    payload,
  };
};
export const add_patient_comment_success = (payload) => {
  return {
    type: SAVE_PATIENT_COMMENT_SUCCESS,
    payload,
  };
};
export const add_patient_comment_failed = (error) => {
  return {
    type: SAVE_PATIENT_COMMENT_FAILED,
    error,
  };
};
export const fetch_patient_comment = (payload) => {
  return {
    type: FETCH_PATIENT_COMMENT,
    payload,
  };
};
export const fetch_patient_comment_success = (payload) => {
  return {
    type: FETCH_PATIENT_COMMENT_SUCCESS,
    payload,
  };
};
export const fetch_patient_comment_failed = (error) => {
  return {
    type: FETCH_PATIENT_COMMENT_FAILED,
    error,
  };
};
export const update_patient_comment = (data) => {
  return {
    type: UPDATE_PATIENT_COMMENT,
    data,
  };
};
export const update_patient_comment_success = (payload) => {
  return {
    type: UPDATE_PATIENT_COMMENT_SUCCESS,
    payload,
  };
};
export const update_patient_comment_failed = (error) => {
  return {
    type: UPDATE_PATIENT_COMMENT_FAILED,
    error,
  };
};
export const delete_patient_comment = (data) => {
  return {
    type: DELETE_PATIENT_COMMENT,
    data,
  };
};
export const delete_patient_comment_success = (payload) => {
  return {
    type: DELETE_PATIENT_COMMENT_SUCCESS,
    payload,
  };
};
export const delete_patient_comment_failed = (error) => {
  return {
    type: DELETE_PATIENT_COMMENT_FAILED,
    error,
  };
};
export const fetch_disease_list = (payload) => {
  return {
    type: FETCH_DISEASE_LIST,
    payload,
  };
};
export const fetch_disease_list_success = (data) => {
  return {
    type: FETCH_DISEASE_LIST_SUCCESS,
    data,
  };
};
export const fetch_disease_list_failed = (error) => {
  return {
    type: FETCH_DISEASE_LIST_FAILED,
    error,
  };
};
export const fetch_patient_disease = (data) => {
  return {
    type: FETCH_PATIENT_DISEASE,
    data,
  };
};
export const fetch_patient_disease_success = (data) => {
  return {
    type: FETCH_PATIENT_DISEASE_SUCCESS,
    data,
  };
};
export const fetch_patient_disease_failed = (error) => {
  return {
    type: FETCH_PATIENT_DISEASE_FAILED,
    error,
  };
};
export const fetch_checkup_dates = (data) => {
  return {
    type: FETCH_CHECKUP_DATES,
    data,
  };
};
export const fetch_checkup_dates_success = (data) => {
  return {
    type: FETCH_CHECKUP_DATES_SUCCESS,
    data,
  };
};
export const fetch_checkup_dates_failed = (data) => {
  return {
    type: FETCH_CHECKUP_DATES_FAILED,
    data,
  };
};
export const add_checkup_date = (data) => {
  return {
    type: ADD_CHECKUP_DATE,
    data,
  };
};
export const add_checkup_date_success = (data) => {
  return {
    type: ADD_CHECKUP_DATE_SUCCESS,
    data,
  };
};
export const add_checkup_date_failed = (data) => {
  return {
    type: ADD_CHECKUP_DATE_FAILED,
    data,
  };
};
export const checkup_mark_as_complete = (data) => {
  return {
    type: CHECKUP_MARK_AS_COMPLETE,
    data,
  };
};
export const checkup_mark_as_complete_success = (data) => {
  return {
    type: CHECKUP_MARK_AS_COMPLETE_SUCCESS,
    data,
  };
};
export const checkup_mark_as_complete_failed = (data) => {
  return {
    type: CHECKUP_MARK_AS_COMPLETE_FAILED,
    data,
  };
};
export const fetch_patients_summary = (data) => {
  return {
    type: FETCH_PATIENTS_SUMMARY,
    data,
  };
};
export const fetch_patients_summary_success = (data) => {
  return {
    type: FETCH_PATIENTS_SUMMARY_SUCCESS,
    data,
  };
};
export const fetch_patients_summary_failed = (data) => {
  return {
    type: FETCH_PATIENTS_SUMMARY_FAILED,
    data,
  };
};
export const generate_patient_id = (data) => {
  return {
    type: GENERATE_PATIENT_ID,
    data,
  };
};
export const generate_patient_id_success = (code) => {
  return {
    type: GENERATE_PATIENT_ID_SUCCESS,
    code,
  };
};
export const generate_patient_id_failed = (data) => {
  return {
    type: GENERATE_PATIENT_ID_FAILED,
    data,
  };
};

export const toggle_patient_status = (payload) => {
  return {
    type: TOGGLE_PATIENT_STATUS,
    payload,
  };
};
export const toggle_patient_status_success = (data) => {
  return {
    type: TOGGLE_PATIENT_STATUS_SUCCESS,
    data,
  };
};
export const toggle_patient_status_failed = (error) => {
  return {
    type: TOGGLE_PATIENT_STATUS_FAILED,
    error,
  };
};

export const reset_new_patient_validation = () => {
  return {
    type: RESET_NEW_PATIENT_VALIDATION,
  };
};

export const reset_report_error = () => {
  return {
    type: RESET_REPORT_ERROR,
  };
};

export const update_sample_patient = (data) => {
  return {
    type: UPDATE_SAMPLE_PATIENT,
    data,
  };
};
export const update_sample_patient_success = (data) => {
  return {
    type: UPDATE_SAMPLE_PATIENT_SUCCESS,
    data,
  };
};
export const update_sample_patient_failed = (error) => {
  return {
    type: UPDATE_SAMPLE_PATIENT_FAILED,
    error,
  };
};

export const refresh_statistics_action = (data) => {
  return {
    type: REFRESH_STATISTICS,
    data,
  };
};

export const generate_report_action = (data) => {
  return {
    type: GENERATE_AUTOMATED_REPORT,
    data,
  };
};

export const generate_report_data_action = (data) => {
  return {
    type: GENERATE_AUTOMATED_REPORT_DATA,
    data,
  };
};

export const generate_report_status_action = (data) => {
  return {
    type: GENERATE_AUTOMATED_REPORT_STATUS,
    data,
  };
};

export const generate_report_success = (data) => {
  return {
    type: GENERATE_REPORT_SUCCESS,
    data,
  };
};

export const generate_report_failed = (data) => {
  return {
    type: GENERATE_REPORT_FAILED,
    data,
  };
};
